<template>
  <div class="stat-card" :class="colorClass">
    <div class="stat-card__body">
      <div class="stat-card__info">
        <p class="stat-card__title">{{ data.title }}</p>
        <div class="stat-card__value-row">
          <span class="stat-card__prefix" v-if="data.prefix">{{ data.prefix }}</span>
          <h3 class="stat-card__value">{{ parseFloat(data.count).toLocaleString() }}</h3>
          <span class="stat-card__suffix" v-if="data.suffix">{{ data.suffix }}</span>
          <span class="stat-card__trend" :class="data.rise ? 'trend-up' : 'trend-down'" v-if="data.inv_status">
            <i class="fa" :class="data.rise ? 'fa-caret-up' : 'fa-caret-down'"></i>
            {{ data.inc }}%
          </span>
        </div>
        <p class="stat-card__date" v-if="data.date.from">
          {{ data.date.from }}<span v-if="data.date.to"> — {{ data.date.to }}</span>
        </p>
      </div>
      <div class="stat-card__icon">
        <i class="fa fa-calendar" v-if="colorClass === 'card-blue'"></i>
        <i class="fa fa-dollar-sign" v-else-if="colorClass === 'card-green'"></i>
        <i class="fa fa-calendar" v-else-if="colorClass === 'card-red'"></i>
        <i class="fa fa-calendar" v-else></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: null }
  },
  computed: {
    colorClass() {
      const map = {
        'header-blue': 'card-blue',
        'header-green': 'card-green',
        'header-red': 'card-red',
        'header-yellow': 'card-yellow'
      };
      return map[this.data.color] || 'card-blue';
    }
  }
};
</script>

<style lang="scss" scoped>
.stat-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  border-left: 4px solid #389ad4;
  padding: 20px 20px 16px;
  height: 100%;

  &.card-blue {
    border-left-color: #389ad4;

    .stat-card__icon {
      background: rgba(21, 101, 192, 0.1);
      color: #389ad4;
    }
  }

  &.card-green {
    border-left-color: #2e7d32;

    .stat-card__icon {
      background: rgba(46, 125, 50, 0.1);
      color: #2e7d32;
    }
  }

  &.card-red {
    border-left-color: #c62828;

    .stat-card__icon {
      background: rgba(198, 40, 40, 0.1);
      color: #c62828;
    }
  }

  &.card-yellow {
    border-left-color: #F58020;

    .stat-card__icon {
      background: rgba(245, 128, 32, 0.12);
      color: #F58020;
    }
  }

  &__body {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }

  &__info {
    flex: 1;
  }

  &__title {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: #7a8499;
    margin: 0 0 8px;
  }

  &__value-row {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-wrap: wrap;
  }

  &__prefix,
  &__suffix {
    font-size: 14px;
    color: #4a5568;
    font-weight: 500;
  }

  &__value {
    font-size: 28px;
    font-weight: 700;
    color: #0d1b3e;
    margin: 0;
    line-height: 1;
  }

  &__trend {
    font-size: 12px;
    font-weight: 600;
    padding: 2px 7px;
    border-radius: 20px;

    &.trend-up {
      background: rgba(46, 125, 50, 0.1);
      color: #2e7d32;
    }

    &.trend-down {
      background: rgba(198, 40, 40, 0.1);
      color: #c62828;
    }
  }

  &__date {
    font-size: 11px;
    color: #a0aab8;
    margin: 8px 0 0;
  }

  &__icon {
    width: 44px;
    height: 44px;
    min-width: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}
</style>
